import React, { useState, useEffect, useRef } from "react";
import "./Balance.css";

interface BalanceProps {
  casinoUserId: string;
}

const Balance: React.FC<BalanceProps> = ({ casinoUserId }) => {
  const [balance, setBalance] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const retryRef = useRef(0);

  useEffect(() => {
    retryRef.current = 0;

    const fetchBalance = async () => {
      if (!casinoUserId) return;

      setError(null);

      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await fetch(
            `${apiUrl}/api/get/balance?casinoUserId=${casinoUserId}`
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        setBalance(data.balance || data.amount || data);
        retryRef.current = 0;
      } catch (err) {
        setError(err instanceof Error ? err.message : "No Data");
        console.error("Balance fetch error:", err);
        retryRef.current++;

        if (retryRef.current >= 3) {
          clearInterval(interval)
          console.error("Balance fetch failed 3 times, aborting");
        }
      }
    };

    fetchBalance().then();

    const interval = setInterval(fetchBalance, 5000);

    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casinoUserId]);

  const formatBalance = (amount: number | null) => {
    if (amount === null) return "N/A";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="balance-container">
      <div className="balance-label">Balance:</div>
      <div className="balance-amount">
        {error ? (
          <span className="balance-error">{error}</span>
        ) : (
          formatBalance(balance)
        )}
      </div>
    </div>
  );
};

export default Balance;
